
import './why-us.scss'

const WhyUs : React.FC = ()=>{
    return (
        <div className='why-us-wrapper'>
            <h1>Why Trowel</h1>
        </div>
    );
};

export default WhyUs;